import { FC, Fragment } from 'react';
import {
  Box,
  Button,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import style from './style';

interface Element {
  title: string;
  onClick?: () => void;
  current?: boolean;
}

interface HeaderNavigator {
  elements: Element[]
}

const HeaderNavigator:FC<HeaderNavigator> = ({ elements }): JSX.Element => {
  const renderElement = ({ title, onClick, current }: Element, index: number): JSX.Element => {
    let jsxElement;
    const jsxTitle = (
      <Typography
        variant={ style.typography.variant }
        sx={ current ? style.current.sx : undefined }
      >
        {title}
      </Typography>
    );
    if (onClick) {
      jsxElement = (
        <Button
          onClick={ onClick }
          variant={ style.button.variant }
          style={ style.button.style }
          sx={ style.button.sx }
        >
          {
            index === 0 && (
              <ArrowBackIcon
                fontSize={ style.icon.fontSize }
                sx={ style.icon.sx }
              />
            )
          }
          {jsxTitle}
        </Button>
      );
    } else {
      jsxElement = (jsxTitle);
    }

    return (
      <Fragment key={ title }>
        { jsxElement }
        { index !== elements.length - 1 &&
        (
          <Typography
            variant={ style.typography.variant }
            sx={ style.divider.sx }
          >
            /
          </Typography>
        )}
      </Fragment>
    );
  };

  return (
    <Box sx={ style.mainBox.sx }>
      <Box
        sx={ style.box.sx }
      >
        {
          elements.map(renderElement)
        }
      </Box>
    </Box>
  );
};

export default HeaderNavigator;
